interface IProps {
  gameBalance: string;
}

const TnCGameTotalPrize: React.FC<IProps> = ({ gameBalance }: IProps) => (
  <div className="prizeWrapper">
    <div className="prizeText">PRIZE POOL</div>
    <div className="prizeValue">{`${gameBalance} BNB`}</div>
  </div>
);

export default TnCGameTotalPrize;
